import { Routes } from '@angular/router';
import { ChiSiamoComponent } from './pages/chi-siamo/chi-siamo.component';
import { HomeComponent } from './pages/home/home.component';
import { DonaComponent } from './pages/dona/dona.component';
import { MappaComponent } from './pages/mappa/mappa.component';
import { EventiComponent } from './pages/eventi/eventi.component';
import { ContattiComponent } from './pages/contatti/contatti.component';
import { StamperiaComponent } from './pages/stamperia/stamperia.component';
import { WgvUnfilteredComponent } from './pages/wgv-unfiltered/wgv-unfiltered.component';
import { GitaMissionariaNapoliComponent } from './pages/gita-missionaria-napoli/gita-missionaria-napoli.component';
import { OhelCampComponent } from './pages/ohel-camp/ohel-camp.component';
import { OhelCampPagamentoCompletatoComponent } from './pages/ohel-camp/pagamento-completato/pagamento-completato.component';
import { OhelCampPagamentoAnnullatoComponent } from './pages/ohel-camp/pagamento-annullato/pagamento-annullato.component';
import { EventoDetailComponent } from './pages/evento-detail/evento-detail.component';
import { IscrizioneDinamicaComponent } from './pages/iscrizione-dinamica/iscrizione-dinamica.component';
import { IscrizionePagamentoCompletatoComponent } from './pages/iscrizione-dinamica/pagamento-completato/pagamento-completato.component';
import { IscrizionePagamentoAnnullatoComponent } from './pages/iscrizione-dinamica/pagamento-annullato/pagamento-annullato.component';
import { OltreIMieiLimitiComponent } from './pages/worship/oltre-i-miei-limiti/oltre-i-miei-limiti.component';
import { IlCieloCantaSantoComponent } from './pages/worship/il-cielo-canta-santo/il-cielo-canta-santo.component';
import { PosterGeneratorComponent } from './pages/poster-generator/poster-generator.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'chi-siamo', component: ChiSiamoComponent },
  { path: 'dona', component: DonaComponent },
  { path: 'mappa', component: MappaComponent },
  { path: 'eventi', component: EventiComponent },
  {
    path: 'eventi/2026/gita-missionaria-napoli',
    component: GitaMissionariaNapoliComponent,
  },
  { path: 'eventi/:year/:slug', component: EventoDetailComponent },
  {
    path: 'eventi/:year/:slug/iscrizione',
    component: IscrizioneDinamicaComponent,
  },
  {
    path: 'iscrizione/pagamento-completato',
    component: IscrizionePagamentoCompletatoComponent,
  },
  {
    path: 'iscrizione/pagamento-annullato',
    component: IscrizionePagamentoAnnullatoComponent,
  },
  { path: 'contatti', component: ContattiComponent },
  { path: 'stamperia', component: StamperiaComponent },
  { path: 'wgv/unfiltered', component: WgvUnfilteredComponent },
  {
    path: 'worship/oltre-i-miei-limiti',
    component: OltreIMieiLimitiComponent,
  },
  {
    path: 'worship/il-cielo-canta-santo',
    component: IlCieloCantaSantoComponent,
  },
  { path: 'ohelcamp', component: OhelCampComponent },
  {
    path: 'ohelcamp/pagamento-completato',
    component: OhelCampPagamentoCompletatoComponent,
  },
  {
    path: 'ohelcamp/pagamento-annullato',
    component: OhelCampPagamentoAnnullatoComponent,
  },
  { path: 'poster', component: PosterGeneratorComponent },
  { path: '**', redirectTo: '' },
];
